import InboxOutlined from '@mui/icons-material/InboxOutlined';
import styled, { keyframes } from 'styled-components';
import { color } from '../Theme';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px 16px;
  text-align: center;
  animation: ${fadeIn} 200ms ease-out;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const IconBadge = styled.span`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${color('primary-light')};
  color: ${color('primary')};
`;

const Message = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${color('primary')};
`;

// Shared empty state: icon, the existing "No records found" text and an optional primary action.
const EmptyState = ({ action = null, icon: IconComponent = InboxOutlined }) => {
    return (
        <Wrap role="status">
            <IconBadge aria-hidden="true">
                <IconComponent />
            </IconBadge>
            <Message>No records found</Message>
            {action}
        </Wrap>
    );
}

export default EmptyState;
